/**
 * Created by root on 7/1/19.
 */
import React from 'react';
import { PeopleSearchBoxList } from "./../okr/wizard/key_results/rolluptable.component";
import SearchBoxComp from '../inputs/searchbox.component';
import WbHttpClient from '../../services/wbhttpclient';

class TLSearchResults extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            classname: this.props.data.className ? this.props.data.className : 'wobo-search-results',
            openTlSearchContainer : true
        };
        this.renderPeopleTeamsSearchResults = this.renderPeopleTeamsSearchResults.bind(this);
        this.searchItemClick = this.searchItemClick.bind(this);
        this.WbHttpClient = new WbHttpClient();
    }

    searchItemClick(e){
        $(e.target).trigger("mouseleave");
        console.log("Search item clicked");
        let rowId = $(e.target).closest('[data-rowid]').attr('data-rowid');
        if (!rowId) return;
        let rowArr = rowId.split('-');
        let type = rowArr[0];
        let userId = rowArr[1];
        let teamId = rowArr[2];
        let callBack = this.props.data.rowClickHandler;
        callBack(type, userId, teamId);
    }

    renderPeopleTeamsSearchResults(values, searchboxInst) {
        let attr = {};
        attr.rowClick = this.searchItemClick;
        if (values.length) {
            $('.krRightPaneContent').parent().animate({ scrollTop: 240 });
            return values.map(v => (
                <PeopleSearchBoxList
                    key={v.type + "_" + v.userId + "_" + v.teamId}
                    row={v}
                    inst={searchboxInst}
                    attr={attr}
                />
            ));
        } else {
            return null;
        }
    }

    render() {
        return (
           <div className={this.state.classname} style={this.state.openTlSearchContainer ? { display: 'block' } : {display: 'none' }}>
               <SearchBoxComp
                   minLength="2"
                   url={"goal/getTeamAndOrgUsersList?team=true&orgTeams=true"}
                   inputProps={{
                       placeholder: localeJsonValue["Search for people or teams"],
                       className: ''
                   }}
                   containerClassName={"time-line-search-results"}
                   wrapperClass={"tl-search-wrapper"}
                   renderResultComp={this.renderPeopleTeamsSearchResults}
               />
           </div>
        );
    }
}

export default TLSearchResults;